import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgV2Bin = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	"xmlns:svgjs": "http://svgjs.com/svgjs",
	viewBox: "0 0 24 24",
	width: 24,
	height: 24,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "matrix(1,0,0,1,0,0)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M 1.5,4.5h21 ",
				stroke: "currentColor",
				fill: "none",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 14.25,1.5h-4.5c-0.828,0-1.5,0.672-1.5,1.5v1.5h7.5V3C15.75,2.172,15.078,1.5,14.25,1.5z ",
				stroke: "currentColor",
				fill: "none",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 9.75,17.25v-7.5 ",
				stroke: "currentColor",
				fill: "none",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 14.25,17.25v-7.5 ",
				stroke: "currentColor",
				fill: "none",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 18.865,21.124C18.8,21.902,18.15,22.5,17.37,22.5H6.631c-0.78,0-1.43-0.598-1.495-1.376 L3.75,4.5h16.5L18.865,21.124z",
				stroke: "currentColor",
				fill: "none",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgV2Bin;
